<template>
	<div>
		<div class="modal" @click.self="close">
			<div>
				<div>
					<transition name="fade">
						<div class="modalbusyoverlay" v-if="isAppBusyModal">
							<div class="busyloader"><div><div></div><div></div><div></div><div></div></div></div>
						</div>
					</transition>
					<div>
						<a data-href @click.prevent="close">Luk</a>
						<h3 v-text="dialogTitle">
							Opret aftale
						</h3>
					</div>
					<section>
						<div>
							<form ref="form" @submit.prevent>
								<div class="form-groups">
									<div class="form-group">
										<div class="input-group" ref="customeridgroup" v-show="dialogMode == 'create_choosecustomer'">
											<label for="customerid">
												Institution
											</label>
											<select v-model="customerID" ref="customerid">
												<option value="0">Vælg institution</option>
												<option v-for="(customer, index) in customers" :key="index" v-bind:value="customer.id">
													{{ customer.name }}
												</option>
											</select><span></span>
										</div>

										<div class="input-group" ref="namegroup">
											<label for="name">
												Aftale navn
											</label>
											<input v-model="name" type="text" ref="name" value>
										</div>

										<div class="input-group" ref="statusgroup">
											<label for="status">
												Status
											</label>
											<select v-model="status" ref="status">
												<option value="1">Afventer</option>
												<option value="2">Godkendt</option>
												<option value="3">Afvist</option>
											</select><span></span>
										</div>
										<div class="input-group" ref="webshopperiodgroup">
											<div class="input-group-hori">
												<div class="input-group nopad">
													<label for="agreementwebshopperiod">
														Webshop start og udløbsdato
													</label>
												</div>
											</div>
											<div class="input-group-hori">
												<div>
													<VueCtkDateTimePicker v-model="agreementwebshopperiod"
																		  :no-label="true"
																		  :no-header="true"
																		  :only-date="true"
																		  :auto-close="true"
																		  button-color="#000"
																		  color="#000"
																		  hint="name"
																		  :first-day-of-week="1"
																		  :no-button-now="true"
																		  :no-shortcuts="true"
																		  :range="true"
																		  placeholder="Vælg periode" />
												</div>
												<div class="nopad">
													<button type="button" class="icon small" @click="agreementwebshopperiod = null">Ryd</button>
												</div>
											</div>
										</div>

										<div class="input-group" ref="languagegroup">
											<label for="language">
												Sprog
											</label>
											<select v-model="language" ref="language">
												<option value="da">Dansk</option>
												<option value="en">Engelsk</option>
											</select><span></span>
										</div>

									</div>
									<div class="form-group">
										<div class="input-group" ref="notesgroup">
											<label for="notes">
												Noter
											</label>
											<textarea v-model="notes" ref="notes" class="large"></textarea>
										</div>
									</div>
								</div>

								<div class="divider"></div>

								<div class="form-groups">
									<div class="form-group form-group-fullwidth" ref="productpackagesgroup">
										<div class="input-group-hori">
											<label for="height">
												Produktpakker
											</label>
										</div>
										<div class="input-group-hori equal draggable-group" v-if="!noProductPackages">
											<draggable group="productpackages"
													   v-bind="productPackagesDragOptions"
													   class="draggable-container draggable-container-target"
													   :list="productPackages"
													   @change="setDraggableIndexes">
												<div class="draggable-item draggable-item-quantity" v-for="(element, index) in productPackages" :key="element.productpackageid" :title="element.internalname">
													<div class="text">
														{{ index + 1 }}. {{ element.name }}<br />
														<div>{{ element.internalname }}</div>
														<div class="type">Pris: {{ element.price }} DK</div>
														<div class="type">Type: {{ getProductPackageType(element) }}</div>
													</div>
												</div>
											</draggable>
											<draggable group="productpackages"
													   v-bind="allProductPackagesDragOptions"
													   class="draggable-container draggable-container-source"
													   :list="allProductPackages">
												<div class="draggable-item" v-for="(element) in allProductPackages" :key="element.productpackageid" :title="element.name">
													{{ element.internalname }}
													<div class="type">Pris: {{ element.price }} DK</div>
													<div class="type">Type: {{ getProductPackageType(element) }}</div>
												</div>
											</draggable>
										</div>
										<div class="input-group-hori" ref="productpackagesgroup" v-if="noProductPackages">
											Der er endnu ikke oprettet nogen produktpakker, der kan tilknyttes aftalen.
										</div>
									</div>
								</div>

								<div class="divider"></div>

								<div class="form-groups">

									<div class="form-group">
										<div class="input-group" ref="pdftitlegroup">
											<label for="pdftitle">
												Bestillings talon titel
											</label>
											<input v-model="pdftitle" type="text" ref="pdftitle" value>
										</div>

										<div class="input-group" ref="pdftextgroup">
											<label for="pdftext">
												Bestillings talon tekst
											</label>
											<quill v-model="pdftextcontent" @text-change="onPDFTextChange" output="html" ref="pdftexteditor" :config="pdftexteditorconfig"></quill>
											<textarea v-model="pdftext" ref="pdftext" class="large" v-if="false"></textarea>
										</div>
									</div>

									<div class="form-group">
										<div class="input-group" ref="pdfgrouptypegroup">
											<label for="pdfgrouptype">
												Institutions type
											</label>
											<select v-model="pdfgrouptype" ref="pdfgrouptype">
												<option value="2">Skole (Klasser)</option>
												<option value="3">Børnehave (Stuer)</option>
												<option value="1">Andet (Grupper)</option>
												<!--<option value="4">Erhverv (Afdelinger)</option>-->
											</select><span></span>
										</div>

										<div class="input-group" ref="datesgroup">
											<label for="date">
												Datoer for fotografering
											</label>
											<div class="input-group-hori" v-for="(schedule, index) in schedules" :key="index" v-bind:value="schedule.id">
												<div style="padding-bottom: 10px;">
													<VueCtkDateTimePicker v-model="schedule.date"
																		  :no-label="true"
																		  :no-header="true"
																		  :only-date="true"
																		  :auto-close="true"
																		  button-color="#000"
																		  color="#000"
																		  hint="name"
																		  :first-day-of-week="1"
																		  :no-button-now="true" />
												</div>
												<div class="nopad">
													<button type="button" class="tiny icon" data-ic="S" @click.self="removeSchedule(schedule.id)"></button>
												</div>
											</div>
											<div class="input-group-hori">
												<div style="text-align: center;">
													<button type="button" class="icon" data-ic="O" @click.self="addSchedule()"></button>
												</div>
												<div></div>
											</div>
										</div>

										<div class="input-group" v-if="dialogMode == 'edit'" v-show="false">
											<label for="agreement">
												Hent bestillings talon
											</label>
											<div class="input-group">
												<div>
													<button type="button" class="small outline" ref="getPDFButton" @click.prevent="getPDF">
														Gem aftale og hent PDF
													</button>
												</div>
											</div>
										</div>
									</div>
								</div>

								<div class="divider"></div>

								<div class="form-groups">

									<div class="form-group">
										<div class="input-group" ref="emailinvitegroup">
											<label for="pdftitle">
												Invitations E-mail emne
											</label>
											<input v-model="inviteemailsubject" type="text" ref="inviteemailsubject" value>
										</div>

										<div class="input-group" ref="inviteemailgroup">
											<label for="inviteemailtext">
												Invitations E-mail tekst
											</label>
											<textarea v-model="inviteemailtext" ref="inviteemailtext" class="large"></textarea>
											<div class="toolbarlinks">
												<h4>System tekster</h4>
												<div>
													<a href="#" @click.prevent="addMergeText('##NAME##', 'inviteemailtext')" title="Navn på forældre">##NAME##</a>
													<a href="#" @click.prevent="addMergeText('##PERSONFIRSTNAME##', 'inviteemailtext')" title="Navn på barnet">##PERSONFIRSTNAME##</a>
													<a href="#" @click.prevent="addMergeText('##CLASS##', 'inviteemailtext')" title="Klasse og skole">##CLASS##</a>
													<a href="#" @click.prevent="addMergeText('##PERIOD##', 'inviteemailtext')" title="Perioden hvor der kan bestilles">##PERIOD##</a>
													<a href="#" @click.prevent="addMergeText('##LINK##', 'inviteemailtext')" title="Bestillings link">##LINK##</a>
												</div>
											</div>
										</div>
									</div>

									<div class="form-group">
										<div class="input-group" ref="smsinvitegroup">
											<label for="notes">
												Invitations SMS tekst
											</label>
											<textarea v-model="invitesmstext" ref="invitesmstext" class="large"></textarea>
											<div class="toolbarlinks">
												<h4>System tekster</h4>
												<div>
													<a href="#" @click.prevent="addMergeText('##NAME##', 'invitesmstext')" title="Navn på forældre">##NAME##</a>
													<a href="#" @click.prevent="addMergeText('##PERSONFIRSTNAME##', 'invitesmstext')" title="Navn på barnet">##PERSONFIRSTNAME##</a>
													<a href="#" @click.prevent="addMergeText('##CLASS##', 'invitesmstext')" title="Klasse og skole">##CLASS##</a>
													<a href="#" @click.prevent="addMergeText('##PERIOD##', 'invitesmstext')" title="Perioden hvor der kan bestilles">##PERIOD##</a>
													<a href="#" @click.prevent="addMergeText('##LINK##', 'invitesmstext')" title="Bestillings link">##LINK##</a>
												</div>
											</div>
										</div>
									</div>

								</div>

								<div class="divider"></div>

								<div class="buttons-group">
									<button type="button" @click.prevent="deleteData" class="delete left" v-if="dialogMode == 'edit'">
										Slet
									</button>
									<button type="button" @click.prevent="close" class="text space">
										Tilbage
									</button>
									<button type="button" @click.prevent="saveData(false)">
										Gem
									</button>
								</div>
							</form>
						</div>
					</section>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { types } from "@/app/types/types"
	import { appFeedbackStateEnum, productPackageTypeEnum } from "@/app/enums/common"
	import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
	import draggable from "vuedraggable"
	import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
	import Quill from 'quill'

	export default {
		name: "AgreementEdit",
		components:
		{
			VueCtkDateTimePicker,
			draggable
		},
		data()
		{
			return {
				dialogMode: "create",
				dialogTitle: "Opret aftale",
				customerID: 0,
				agreementID: 0,
				customer: null,
				customers: [],
				allProductPackages: [],
				productPackages: [],
				noProductPackages: true,
				returntocustomer: false,
				agreementwebshopperiod: null,

				name: "",
				status: "1",
				date: "",
				language: "da",
				notes: "",
				pdftitle: "",
				pdftext: "",
				pdfgrouptype: "2",
				schedules: [{}],
				inviteemailsubject: "",
				inviteemailtext: "",
				invitesmstext: "",

				pdftextcontent: "",
				pdftexteditorconfig:
				{
					modules: {
						toolbar: ["bold", "italic", "underline"]
					}
				},

				agreement: {
					name: "",
					status: "1",
					notes: "",
					language: "da",
					pdftitle: "",
					pdftext: "",
					pdfgrouptype: "2",
					schedules: [{}],
					productpackages: [],
					startdate: null,
					expirationdate: null,
					inviteemailsubject: "",
					inviteemailtext: "",
					invitesmstext: ""
				},
			}
		},
		async mounted()
		{
			this.setModalIsVisible()
			this.customerID = this.$route.params.customerid
			this.agreementID = this.$route.params.agreementid
			this.returntocustomer = (this.$route.name == "AgreementEdit")
			this.setAppAsBusyModal()
			document.getElementsByClassName("field-input")[0].setAttribute("placeholder", "Vælg dato")

			this.pdftexteditor = this.$refs.pdftexteditor
			this.loadProductPackages()

			if (this.customerID == null)
			{
				this.customerID = 0
				this.dialogMode = "create_choosecustomer"

				var response = await this.$store.dispatch(types.ACTION_GET_CUSTOMERS)

				if (response.status == 200)
				{
					this.customers = response.data
					this.setAppAsIdle()
				}
				else
				{
					this.setAppAsIdle()
					logError("AgreementEdit.loadCustomers", error)
					this.showErrorAlert("Der opstod en fejl. Opdater siden og prøv igen.")
				}
			}
			else
			{
				var response = await this.$store.dispatch(types.ACTION_GET_CUSTOMER, this.customerID)

				if (response.status == 200)
				{
					this.customer = response.data

					if (this.agreementID && this.agreementID != 0)
					{
						this.loadData()
						this.dialogMode = "edit"
						this.dialogTitle = "Rediger aftale for " + this.customer.name
						this.agreementID = this.$route.params.agreementid
					}
					else
					{
						this.dialogMode = "create"
						this.dialogTitle = "Opret aftale for " + this.customer.name
						this.$refs.name.focus()
					}
					this.setAppAsIdle()
				}
				else
				{
					this.setAppAsIdle()
					logError("Agreement.mounted()", error)
					this.showErrorAlert("Der opstod en fejl. Opdater siden og prøv igen.")
				};
			}
		},
		destroyed()
		{
			this.setModalNotVisible()
		},
		computed: {
			allProductPackagesDragOptions()
			{
				return {
					sort: false,
					easing: "cubic-bezier(1, 0, 0, 1)",
					animation: 200,
					ghostClass: "ghost",
					dragClass: "chosen"
				}
			},
			productPackagesDragOptions()
			{
				return {
					easing: "cubic-bezier(1, 0, 0, 1)",
					animation: 200,
					ghostClass: "ghost",
					dragClass: "chosen"
				}
			}
		},

		methods:
		{
			getProductPackageType(productpackage)
			{
				switch (productpackage.type)
				{
					case productPackageTypeEnum.PICTUREPACKAGE:
						return "Billedepakke"
					case productPackageTypeEnum.PICTUREPACKAGEEXTRA:
						return "Ekstra ved pakkekøb"
					case productPackageTypeEnum.WITHOUTPICTUREPACKAGE:
						return "Uden pakkekøb"
					case productPackageTypeEnum.ADDON:
						return "Tilkøbsprodukt"
					case productPackageTypeEnum.FREIGHTANDSERVICE:
						return "Fragt og service"
					case productPackageTypeEnum.FREIGHTANDSERVICEREQUIRED:
						return "Fragt og service (Krævet)"
					case productPackageTypeEnum.AFTERPICTUREPACKAGE:
						return "Nyt motiv"
					case productPackageTypeEnum.PICTUREPACKAGESECONDARY:
						return "Billedepakke sekundær"
				}
			},
			onPDFTextChange(editor)
			{
				this.pdftext = editor.root.innerHTML
			},
			getPDF()
			{
				this.saveData(true)
			},
			addMergeText(text, textfieldname)
			{
				var textbox = this.$refs[textfieldname]
				this.insertAtCursor(textbox, text)
			},
			insertAtCursor(myField, myValue)
			{
				//IE support
				if (document.selection)
				{
					myField.focus()
					sel = document.selection.createRange()
					sel.text = myValue
				}
				//MOZILLA and others
				else if (myField.selectionStart || myField.selectionStart == '0')
				{
					var startPos = myField.selectionStart
					var endPos = myField.selectionEnd
					myField.value = myField.value.substring(0, startPos)
						+ myValue
						+ myField.value.substring(endPos, myField.value.length)
					myField.selectionStart = startPos + myValue.length
					myField.selectionEnd = startPos + myValue.length
				} else
				{
					myField.value += myValue
				}
			},
			addSchedule()
			{
				let newScheduleID = -1

				for (var schedule of this.schedules)
				{
					if (schedule.id < 0)
					{
						newScheduleID = schedule.id--
					}
				}

				let newDate = new Date()

				if (this.schedules.length > 0)
				{
					let newestSchedule = this.schedules[this.schedules.length - 1]
					let scheduleDate = new Date(newestSchedule.date)
					newDate = new Date(scheduleDate.getTime() + 1000 * 60 * 60 * 24)
				}

				let newSchedule = {
					id: newScheduleID,
					agreementid: this.agreementID,
					date: this.getDateString(newDate),
					starttime: this.getDateString(newDate),
					endtime: this.getDateString(newDate),
				}

				var lala = this.agreement.schedules
				this.schedules.push(newSchedule)
			},
			removeSchedule(scheduleid)
			{
				this.schedules = this.schedules.filter((schedule) => { return schedule.id !== scheduleid })
			},
			checkForChanges()
			{
				var changes = false

				changes = changes || (this.dialogMode == "create_choosecustomer" && this.customerID != 0)
				changes = changes || (this.name != this.agreement.name)
				changes = changes || (this.status != this.agreement.status)
				changes = changes || (this.notes != this.agreement.notes)
				changes = changes || (this.pdftitle != this.agreement.pdftitle)
				changes = changes || (this.pdftext != this.agreement.pdftext)
				changes = changes || (this.pdfgrouptype != this.agreement.pdfgrouptype)
				changes = changes || ((this.dialogMode == "create" || this.dialogMode == "create_choosecustomer") && this.schedules[0].date != null)

				if (!changes && this.dialogMode == "edit")
				{
					let newSchedules = this.schedules.find(sc => sc.id < 0)

					if (newSchedules)
					{
						changes = true
					}
					else
					{
						for (var schedule of this.agreement.schedules)
						{
							let existingSchedule = this.schedules.find(sc => sc.id == schedule.id)

							if (!existingSchedule)
							{
								changes = true
								break
							}
							else if (schedule.date != existingSchedule.date)
							{
								changes = true
								break
							}
						}
					}

					if (!changes)
					{
						for (var productPackage of this.agreement.productpackages)
						{
							let existingProductPackage = this.productPackages.find(ppp => ppp.productpackageid == productPackage.productpackageid)

							if (existingProductPackage)
							{
								if (productPackage.index != existingProductPackage.index)
								{
									changes = true
									break
								}
							}
							else
							{
								changes = true
								break
							}
						}

						for (var productPackage of this.productPackages)
						{
							let newProductPackage = this.agreement.productpackages.find(pp => pp.productpackageid == productPackage.productpackageid)

							if (!newProductPackage)
							{
								changes = true
								break
							}
						}
					}
				}

				if (changes)
				{
					return !confirm("Der er ændringer der ikke er gemt. Vil du lukke dialogen?")
				}

				return false
			},
			close()
			{
				if (this.checkForChanges())
				{
					return
				}

				this.returnToList()
			},
			setDraggableIndexes()
			{
				let index = 0
				for (var productPackage of this.productPackages)
				{
					index++
					productPackage.index = index
				}
			},
			async loadProductPackages()
			{
				var productPackagesResult = await this.$store.dispatch(types.ACTION_GET_PRODUCTPACKAGES)

				if (productPackagesResult.status == 200)
				{
					if (productPackagesResult.data && productPackagesResult.data.length > 0)
					{
						this.noProductPackages = false

						for (var productpackage of productPackagesResult.data)
						{
							var sortProductPackage =
							{
								id: 0,
								productpackageid: productpackage.id,
								name: productpackage.name,
								internalname: productpackage.internalname,
								price: productpackage.price,
								type: productpackage.type
							}

							this.allProductPackages.push(sortProductPackage)
						}

						this.allProductPackages = this.allProductPackages.sort((a, b) =>
						{
							if (a.internalname == b.internalname) { return -1 }
							if (a.internalname < b.internalname) { return -1 }
							if (a.internalname > b.internalname) { return 1 }
							return 0
						})
					}
				}
				else
				{
					this.setAppAsIdle()
					logError("AgreementEdit.loadProductPackages()", error)
					this.showErrorAlert("Der opstod en fejl. Opdater siden og prøv igen.")
					this.returnToList()
				}
			},
			returnToList()
			{
				if (this.returntocustomer)
				{
					this.$router.push({ name: "Agreements", params: { customerid: this.customerID } })
				}
				else
				{
					this.$router.push({ name: "AgreementsAll" })
				}
			},
			async deleteData()
			{
				if (confirm("Er du sikker? Sletningen kan ikke fortrydes."))
				{
					try
					{
						await this.$store.dispatch(types.ACTION_DELETE_AGREEMENT, this.agreementID)
							.then(response =>
							{
								this.setAppAsIdle()
								this.setAppFeedbackState(appFeedbackStateEnum.SUCCESS)
								this.returnToList()
							})
							.catch(error =>
							{
								this.setAppAsIdle()
								logError("Agreement.deleteData()", error)
								this.showErrorAlert("Der opstod en fejl. Opdater siden og prøv igen.")
							})
					}
					catch (error)
					{
						this.setAppAsIdle()
						logError("AgreementEdit.deleteData()", error)
						this.showErrorAlert("Der opstod en fejl. Opdater siden og prøv igen.")
						this.returnToList()
					}
				}
			},
			updateAgreementState(data, updateProductPackages = true)
			{
				this.agreement = data
				this.name = data.name
				this.status = data.status
				this.notes = data.notes
				this.language = data.language

				if (this.language === "" || this.language === null)
				{
					this.language = "da"
				}

				this.pdftitle = data.pdftitle
				this.pdftext = data.pdftext
				this.pdftexteditor.editor.container.firstChild.innerHTML = data.pdftext

				this.pdfgrouptype = data.pdfgrouptype
				this.inviteemailsubject = data.inviteemailsubject
				this.inviteemailtext = data.inviteemailtext
				this.invitesmstext = data.invitesmstext
				this.agreementwebshopperiod =
				{
					start: data.startdate ? data.startdate : null,
					end: data.expirationdate ? data.expirationdate : null
				}

				this.schedules = []
				for (var schedule of data.schedules)
				{
					let newSchedule = {
						id: schedule.id,
						agreementid: schedule.agreementid,
						date: schedule.date,
						starttime: schedule.startime,
						endtime: schedule.endtime
					}

					this.schedules.push(newSchedule)
				}

				if (updateProductPackages)
				{
					this.productPackages = []

					if (data.productpackages && data.productpackages.length > 0)
					{
						for (var productPackage of data.productpackages)
						{
							var findProductPackage = this.allProductPackages.find(pp => pp.productpackageid == productPackage.productpackageid)

							var addProductPackage =
							{
								id: productPackage.id,
								agreementid: productPackage.aagreementid,
								productpackageid: productPackage.productpackageid,
								index: productPackage.index,
								name: findProductPackage.name,
								internalname: findProductPackage.internalname,
								price: findProductPackage.price,
								type: findProductPackage.type
							}

							this.productPackages.push(addProductPackage)
						}

						var allProductPackagesTraversed = this.allProductPackages

						for (var productPackage of this.allProductPackages)
						{
							var existingProductPackage = this.productPackages.find(pp => pp.productpackageid == productPackage.productpackageid)

							if (existingProductPackage)
							{
								existingProductPackage.name = productPackage.name
								allProductPackagesTraversed = allProductPackagesTraversed.filter(productPackage => productPackage.productpackageid != existingProductPackage.productpackageid)
							}
						}

						this.allProductPackages = allProductPackagesTraversed
					}

					this.setDraggableIndexes()
				}
			},
			getDateString(date)
			{
				return date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + date.getDate()).slice(-2)
			},
			async loadData()
			{
				if (this.agreementID)
				{
					try
					{
						var result = await this.$store.dispatch(types.ACTION_GET_AGREEMENT, this.agreementID)

						if (result.status == 200)
						{
							this.updateAgreementState(result.data)
							this.setAppAsIdle()
						}
						else
						{
							this.setAppAsIdle()
							logError("AgreementEdit.loadData()", error)
							this.showErrorAlert("Der opstod en fejl. Opdater siden og prøv igen.")
							this.returnToList()
						}
					}
					catch (error)
					{
						this.setAppAsIdle()
						logError("AgreementEdit.loadData()", error)
						this.showErrorAlert("Der opstod en fejl. Opdater siden og prøv igen.")
						this.returnToList()
					}
				}
				else
				{
					alert("Forkert adresse. Opdater venligst siden, og prøv igen. 1")
					this.returnToList()
				}
			},
			async saveData(downloadPDF)
			{
				try
				{

					var valid = true
					var validationFocus = false

					if (this.dialogMode == "create_choosecustomer")
					{
						if (this.customerID == 0)
						{
							this.$refs.customeridgroup.setAttribute("data-validation", "Vælg venligst en institution")
							validationFocus = true
							valid = false
						}
						else
						{
							this.$refs.customeridgroup.removeAttribute("data-validation")
						}
					}

					if (this.name.length == 0)
					{
						this.$refs.namegroup.setAttribute("data-validation", "Indtast venligst et navn")
						if (!validationFocus) this.$refs.name.focus()
						validationFocus = true
						valid = false
					}
					else
					{
						this.$refs.namegroup.removeAttribute("data-validation")
					}

					/*if (!this.agreementwebshopperiod || !this.agreementwebshopperiod.start || !this.agreementwebshopperiod.end)
					{
						this.$refs.webshopperiodgroup.setAttribute("data-validation", "Vælg venligst den aktive webshop periode for aftalen")
						valid = false
					}
					else
					{
						this.$refs.webshopperiodgroup.removeAttribute("data-validation")
					}*/

					if ((!this.allProductPackages || !this.productPackages) || this.productPackages.length == 0)
					{
						this.$refs.productpackagesgroup.setAttribute("data-validation", "Vælg venligst mindst en produktpakke til aftalen")
						valid = false
					}
					else
					{
						this.$refs.productpackagesgroup.removeAttribute("data-validation")
					}

					if (this.pdftitle.length == 0)
					{
						this.$refs.pdftitlegroup.setAttribute("data-validation", "Indtast en titel til bestillings talonen")
						if (!validationFocus) this.$refs.pdftitle.focus()
						validationFocus = true
						valid = false
					}
					else
					{
						this.$refs.pdftitlegroup.removeAttribute("data-validation")
					}

					if (this.pdftext.length == 0)
					{
						this.$refs.pdftextgroup.setAttribute("data-validation", "Indtast en tekst til bestillings talonen")
						if (!validationFocus) this.$refs.pdftext.focus()
						validationFocus = true
						valid = false
					}
					else
					{
						this.$refs.pdftextgroup.removeAttribute("data-validation")
					}

					if (!this.schedules || this.schedules.length == 0 || (this.schedules[0].date == null))
					{
						this.$refs.datesgroup.setAttribute("data-validation", "Tilføj venligst en eller flere datoer")
						validationFocus = true
						valid = false
					}
					else
					{
						this.$refs.datesgroup.removeAttribute("data-validation")
					}

					if (!valid)
					{
						return
					}

					this.setAppAsBusyModal()

					var data =
					{
						id: this.agreementID,
						customerid: this.customerID,
						name: this.name,
						status: this.status,
						language: this.language,
						notes: this.notes,
						pdftitle: this.pdftitle,
						pdftext: this.pdftext,
						pdfgrouptype: this.pdfgrouptype,
						inviteemailsubject: this.inviteemailsubject,
						inviteemailtext: this.inviteemailtext,
						invitesmstext: this.invitesmstext,
						schedules: this.schedules,
						productpackages: this.productPackages,
						startdate: this.agreementwebshopperiod && this.agreementwebshopperiod.start ? this.agreementwebshopperiod.start : null,
						expirationdate: this.agreementwebshopperiod && this.agreementwebshopperiod.end ? this.agreementwebshopperiod.end : null
					}

					for (var schedule of this.schedules)
					{
						var date = new Date(schedule.date)
						date = this.getDateString(date)
						schedule.date = date
						schedule.starttime = date + " 00:00:00"
						schedule.endtime = date + " 23:59:59"
					}

					if (this.dialogMode == "edit")
					{
						var saveResult = await this.$store.dispatch(types.ACTION_UPDATE_AGREEMENT, data)

						if (saveResult.status == 200)
						{
							this.updateAgreementState(saveResult.data, false)

							if (downloadPDF)
							{
								var pdfResult = await this.$store.dispatch(types.ACTION_DOWNLOAD_ORDERING_PDF_PERSON, {
									personid: 0,
									agreementid: this.agreementID,
									filename: "ImageMakersBestillingsTalon_" + this.customer.name.replace(" ", "_") + "-" + this.name.replace(" ", "_") + ".pdf"
								})

								if (pdfResult.status == 200)
								{
									this.setAppAsIdle()
									this.setAppFeedbackState(appFeedbackStateEnum.SUCCESS)
								}
								else
								{
									this.$refs.pdfagreementwrapper.setAttribute("data-error", "Der opstod en fejl ved generering af PDF. Opdater siden og prøv igen.")
									this.setAppAsIdle()
								}
							}
							else
							{

								this.setAppAsIdle()
								this.setAppFeedbackState(appFeedbackStateEnum.SUCCESS)
								this.returnToList()
							}
						}
						else
						{
							this.setAppAsIdle()
							logError("Agreement.saveData()", saveResult.error)
							this.showErrorAlert("Der opstod en fejl. Opdater siden og prøv igen.")
						}
					}
					else
					{
						await this.$store.dispatch(types.ACTION_ADD_AGREEMENT, data)
							.then(response =>
							{
								this.agreement = response.data
								this.setAppAsIdle()
								this.setAppFeedbackState(appFeedbackStateEnum.ADDED)
								this.returnToList()
							})
							.catch(error =>
							{
								this.setAppAsIdle()
								logError("Agreement.saveData()", error)
								this.showErrorAlert("Der opstod en fejl. Opdater siden og prøv igen.")
							})
					}
				}
				catch (error)
				{
					this.setAppAsIdle()
					logError("Agreement.saveData()", error)
					this.showErrorAlert("Der opstod en fejl. Opdater siden og prøv igen.")
				}
			}
		}
	}
</script>